/**
 * The FAQ answers on audiotrader.co.uk/pages/faqs, for links in staff replies
 * (spec docs/specs_20261102_inbox_deflection.md, W6).
 *
 * A fixed list, chosen on 2026-11-02 over reading Shopify live. The answers
 * themselves live in Shopify (Content > Metaobjects > Help article); each
 * handle here is that article's handle. When an FAQ answer is added or
 * renamed in Shopify, add or change its line here too.
 *
 * `topics` are keys from shared/ticketTopics.js: a ticket with that topic
 * offers this answer first, and the AI suggest may link it.
 */

export const FAQ_BASE_URL = 'https://www.audiotrader.co.uk/pages/faqs';

export const FAQ_LINKS = Object.freeze([
    { handle: 'getting-a-quote', question: 'How do I get a quote?', topics: ['how_it_works', 'seller_other'] },
    { handle: 'how-selling-works', question: 'How does selling to Audio Trader work?', topics: ['how_it_works', 'status'] },
    { handle: 'what-we-buy', question: 'Do you buy my kind of gear?', topics: ['do_you_buy'] },
    { handle: 'how-we-price', question: 'How do you work out my offer?', topics: ['price_wrong'] },
    { handle: 'how-long-a-quote-lasts', question: 'How long does my quote last?', topics: ['accept_decline'] },
    { handle: 'if-something-is-wrong', question: "What if my gear isn't as described?", topics: ['price_wrong', 'complaint'] },
    { handle: 'dropping-gear-off', question: 'Can I drop my gear off instead?', topics: ['drop_off', 'booking'] },
    { handle: 'no-printer', question: "I don't have a printer. What do I do?", topics: ['labels_printer'] },
    { handle: 'who-books-the-courier', question: 'Who books the courier?', topics: ['booking', 'courier_no_show'] },
    { handle: 'how-you-get-paid', question: 'How and when do I get paid?', topics: ['when_paid', 'bank_details'] },
    { handle: 'wheres-my-order', question: "Where's my order?", topics: ['order_status'] },
    { handle: 'returning-an-item', question: 'Can I return something I bought?', topics: ['returns', 'missing_parts'] },
]);

/** The public address of one FAQ answer. */
export function faqUrl(handle) {
    return `${FAQ_BASE_URL}/${handle}`;
}

/** FAQ answers for a ticket topic, best match first. Empty for no topic or no match. */
export function faqLinksForTopic(topic) {
    if (!topic) return [];
    return FAQ_LINKS.filter((link) => link.topics.includes(topic));
}

/** The line staff insert into a reply: the question, then the link. */
export function faqReplyLine(link) {
    return `${link.question} ${faqUrl(link.handle)}`;
}
